import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { ArrowNavigator } from "@ui/components/arrowNavigator";
import { useShareroomGuidecontroller } from "@ui/components/group/shareroom/shareroomGuide/shareroomGuidecontroller/shareroomGuidecontrollerContext";

export const ShareroomGuideNavigation: React.FC = () => {
	const controller = useShareroomGuidecontroller();
	const step = useObservable(controller.step);

	return (
		<StyledArrowNavigator
			next={step !== "ACTIVITY" ? () => controller.next() : undefined}
			previous={step !== "DASHBOARD" ? () => controller.previous() : undefined}
		/>
	);
};

const StyledArrowNavigator = styled(ArrowNavigator)`
	justify-content: flex-end;
	gap: 20px;
`;
